import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
    history: createWebHistory('/online'),
    routes: [
        {
            name: 'Online Appointments',
            path: '/:publicId',
            component: () => import('@/modules/appointments/OnlineAppointments.vue'),
            meta: { isGrouped: false }
        },
        {
            name: 'Online Grouped Appointments',
            path: '/:publicId/grouped',
            component: () => import('@/modules/appointments/OnlineAppointments.vue'),
            meta: { isGrouped: true }
        },
        {
            name: 'Donation Widget',
            path: '/:publicId/donations/:campaignId',
            component: () => import('@/modules/donations/Donations.vue'),
            meta: { isGrouped: false }
        },
        {
            name: 'Donation Small Widget',
            path: '/:publicId/donations/:campaignId/small',
            component: () => import('@/modules/donations/small-widget/SmallWidget.vue')
        }
    ]
})

export default router
